import React from "react";
import PdfViewer from "../../PdfViewer";

const PolizaMgavilan2025Fw = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/251015-Poliza-de-Servicios_Firewall.pdf`;
  /*const pdfUrl = "/pdf/251015-Poliza-de-Servicios_Firewall.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Póliza 2025 Firewall</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PolizaMgavilan2025Fw;
